import PropTypes from 'prop-types';
import React from 'react';

import * as config from './config';

const WechatAuthorization = (props) => {
  const { className, buttonText, children, tag, type } = props;

  const onAuthorizationHandler = () => {
    const { appID, redirectUri } = props;

    window.location.href = `${config.API_AUTHENTICATION_WECHAT}?appid=${appID}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${config.RESPONSE_TYPE}&scope=${config.SCOPE_DEFAULT}`;
  };
  
  return React.createElement(
    tag,
    {
      className: className,
      onClick: onAuthorizationHandler,
      style: className ? {} : config.STYLE_DEFAULT,
      type
    },
    children || buttonText
  );
};


WechatAuthorization.defaultProps = {
  buttonText: config.BUTTON_TEXT,
  tag: config.NAME_TAG,
  type: config.TYPE,
  state: config.REDIRECT_DEFAULT
};

WechatAuthorization.propTypes = {
  appID: PropTypes.string.isRequired,
  redirectUri: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  scope: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  tag: PropTypes.string,
  type: PropTypes.string,
  state: PropTypes.string,
};

export default WechatAuthorization;
